module.exports = __webpack_public_path__ + "img/04_1_3_3.f83b2c34.png";